

































import { Component, Watch } from 'vue-property-decorator';
import { JournalEntriesModule } from '@/store/Accounting/JournalEntriesModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import JournalEntry from '@/models/Accounting/JournalEntries/JournalEntry';
import PageNames from '@/router/PageNames';

@Component({ name: 'JournalEntries', components: { Alert }, metaInfo: { title: 'Journal Entries' } })
export default class extends SaascadaVue {

    // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
    headers = [
        { text: this.$t('pageText.journalEntries.fields.date'), value: 'date', sortable: false, width: '10%' },
        { text: this.$t('pageText.journalEntries.fields.eventType'), value: 'eventType', sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.transactionType'), value: 'transactionType', sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.debitAccount'), sortable: false, width: '18%' },
        { text: this.$t('pageText.journalEntries.fields.debitAmount'), sortable: false, width: '12%' },
        { text: this.$t('pageText.journalEntries.fields.creditAccount'), sortable: false, width: '18%' },
        { text: this.$t('pageText.journalEntries.fields.creditAmount'), sortable: false, width: '12%' }
    ];
    search = '';
    journalEntriesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.journalEntriesPage = +page;
        }
    }

    async beforeMount() {
        await JournalEntriesModule.getJournalEntries();
    }

    get journalEntries() {
        return JournalEntriesModule.journalEntries;
    }

    get totalJournalEntriesPages() {
        return JournalEntriesModule.totalJournalEntriesPages;
    }

    get loading() {
        return JournalEntriesModule.loadingJournalEntries;
    }

    get pageSize() {
        return JournalEntriesModule.pageSize;
    }

    @Watch('journalEntriesPage')
    async onJournalEntriesPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.journalEntriesPage}` } });
    }

    async navigateToJournalEntry(journalEntry: JournalEntry) {
        this.$router.push({ name: PageNames.JournalEntry, params: { id: journalEntry.id }, query: { tab: "0" } });
    }

}
